module.exports = __webpack_public_path__ + "img/home-autoplus.f26d4836.png";